export default class EncryptedTransferInteraction {
  uploadId!: string;
  iv!: string;
  data!: string;
  kind!: 'approval' | 'comment' | 'download';
  created!: string;
}
